<div class="country-switcher" (click)="toggleDropDown()">
  <div class="selectedCountry">
    <img async [src]="countryOptions[selectedCountry].icon" />
  </div>
</div>
<div *ngIf="showDropDown" class="country-switcher-overlay" (click)="toggleDropDown()"></div>
<div *ngIf="showDropDown" (click)="$event.stopPropagation()">
  <div class="country-switcher-dropdown">
    <div class="nav">
      <button class="nav-btn" (click)="toggleDropDown()">
        <img src="https://static.zip.co/icons/arrow-back.svg" />
        Back
      </button>
    </div>
    <h3>Select your country or region</h3>
    <div
      class="country"
      *ngFor="let country of countryOptions | keyvalue"
      (click)="onSelect(country.key, country.value.path)"
    >
      <input
        type="radio"
        value="{{ country.key }}"
        [attr.checked]="selectedCountry === country.key ? 'checked' : null"
        name="countryCode"
        id="countryCode_{{ country.key }}"
      />
      <label for="countryCode_{{ country.key }}">
        <div class="country-img">
          <img async src="{{ country.value.icon }}" />
        </div>
        <div class="country-name">{{ country.value.name }}</div>
        <div class="country-check">
          <img src="https://static.zip.co/icons/check.svg" />
        </div>
      </label>
    </div>
  </div>
</div>
